var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 23.8462C0.5 33.8759 6.93125 42.3743 15.8125 45.5134V2.179C6.93125 5.31807 0.5 13.8165 0.5 23.8462Z",
    fill: "#75A843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4375 23.8462C46.4375 13.8165 40.0062 5.31807 31.125 2.179V45.5134C40.0828 42.3743 46.4375 33.8759 46.4375 23.8462Z",
    fill: "#ED4C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 45.5134C18.1859 46.3556 20.7891 46.8149 23.4688 46.8149C26.1484 46.8149 28.7516 46.3556 31.125 45.5134V2.179C28.7516 1.33682 26.1484 0.877441 23.4688 0.877441C20.7891 0.877441 18.1859 1.33682 15.8125 2.179V45.5134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.7a83e1e91f533e38e2d36beee3874e54.svg";
export { ForwardRef as ReactComponent };